export default {
	updateLoadingStatus (state, payload) {
	  state.isLoading = payload.isLoading
	},
	clearBuyInput (state, data) {
		state.clearBuyInput = data
	},
	['SAVE_ALLSLOADING'] (state, data) {
		state.allSLoading = data
	},
	['SAVE_LOGINED'] (state, data) {
		state.logined = data
	},
	['SAVE_ISBINDCARD'] (state, data) {
		state.isBindCard = data
	},
	tabBarNumber (state, data) {
		state.tabBarNumber = data
	},
	/** 客户客服信息 */
	SET_CUSTOMER_HOTLINE (state, data) {
		state.hotLine = data;
	},
}


// WEBPACK FOOTER //
// ./src/store/mutations.js